import { Types } from "../actions/integrationActions";
import _ from "lodash";

const integrationReducers = (state, action) => {
	switch (action.type) {
		case Types.INTEGRATION_EMPLOYEE_LINK: {
			let newState = _.cloneDeep(state);

			newState.employee[`${action.integration}Link`] = action.employee;

			return newState;
		}
		case Types.INTEGRATION_IMPORT_MODAL: {
			let newState = _.cloneDeep(state);

			newState.integration.importEmployeeModal = action.status ? action.status : undefined;

			return newState;
		}

		case Types.INTEGRATION_BULK_LINK_MODAL: {
			let newState = _.cloneDeep(state);

			newState.integration.bulkLinkModal = action.status ? action.status : undefined;

			return newState;
		}

		case Types.INTEGRATION_GET_LIST: {
			let newState = _.cloneDeep(state);

			const newStateIntegration = newState.integration || {};
			const newStateMyIntegration = newState.my.integration || {};
			const { orgIntegrations, userIntegrations, integrationDetails = {} } = action.response;

			const [integration, myIntegration] = [
				[newStateIntegration, orgIntegrations],
				[newStateMyIntegration, userIntegrations],
			].map(([existingIntegration, incomingIntegration]) => {
				//compare two objects and update the existing one with the incoming one
				//if there is a missing key in the incoming one, it will be deleted from the existing one
				//if there is a missing key in the existing one, it will be added from the incoming one
				//one level sub keys will be compared and updated

				const existingIntegrationKeys = Object.keys(existingIntegration);
				const incomingIntegrationKeys = Object.keys(incomingIntegration);

				const keysToDelete = _.difference(existingIntegrationKeys, incomingIntegrationKeys);
				const keysToAdd = _.difference(incomingIntegrationKeys, existingIntegrationKeys);

				const keysToUpdate = _.intersection(existingIntegrationKeys, incomingIntegrationKeys);

				const updatedIntegration = _.cloneDeep(existingIntegration);

				keysToDelete.forEach((key) => delete updatedIntegration[key]);
				keysToAdd.forEach((key) => (updatedIntegration[key] = incomingIntegration[key]));

				keysToUpdate.forEach((key) => {
					const existingIntegrationSubKeys = Object.keys(existingIntegration[key]);
					const incomingIntegrationSubKeys = Object.keys(incomingIntegration[key]);

					const subKeysToDelete = _.difference(existingIntegrationSubKeys, incomingIntegrationSubKeys);
					const subKeysToAdd = _.difference(incomingIntegrationSubKeys, existingIntegrationSubKeys);

					const subKeysToUpdate = _.intersection(existingIntegrationSubKeys, incomingIntegrationSubKeys);

					subKeysToDelete.forEach((subKey) => delete updatedIntegration[key][subKey]);
					subKeysToAdd.forEach(
						(subKey) => (updatedIntegration[key][subKey] = incomingIntegration[key][subKey]),
					);
					subKeysToUpdate.forEach(
						(subKey) => (updatedIntegration[key][subKey] = incomingIntegration[key][subKey]),
					);
				});

				return updatedIntegration;
			});

			newState.integration = integration;
			newState.my.integration = myIntegration;
			newState.integrationDetails = integrationDetails;
			newState.notifications.integrations = [];

			const workforce = newState.integration?.timeAttendance?.tanda;

			const isWorkforceEnabled = !!workforce;
			const isWorkforceConnected = workforce?.connected;

			if (isWorkforceEnabled && !isWorkforceConnected) {
				newState.notifications.integrations.push({
					title: "Workforce Disconnected",
					description: "Your connection to Workforce has been disconnected. Click here to reconnect.",
					source: "Integrations",
					read: false,
					type: "Workforce",
					company: true,
					directTo: {
						text: "Reconnect",
						link: "/settings/integrations",
					},
				});
			}

			return newState;
		}

		case Types.INTEGRATION_USER_CONNECTED_ORGS_MODAL: {
			let newState = _.cloneDeep(state);

			newState.my.userConnectedIntegration = action.integration;

			return newState;
		}

		case Types.INTEGRATION_USER_CONNECTED_ORGS: {
			let newState = _.cloneDeep(state);

			newState.my.userConnectedOrgs = action.response.linkedOrganisations;

			return newState;
		}

		default:
			return state;
	}
};

export default integrationReducers;
